import React from "react";
import ticketBG from "../../assets/img/ticket.png";

const TicketItem = ({
  AWAITING_ASSIGN,
  ticket,
  AWAITING_DRAW,
  poolData,
  contractInfo,
  isClaimed,
  index,
}) => {
  const fixedAmount = (amount) => {
    return Number(amount) <= 0.0099
      ? Number(amount).toFixed(4)
      : Number(amount).toFixed(2);
  };
  return (
    <>
      <div
        className={"ticket-item"}
        style={
          index % 9 === 5
            ? { marginLeft: "5%" }
            : {} && index % 9 === 8
            ? { marginRight: "5%" }
            : {}
        }
      >
        <img className="w-100" src={ticketBG} alt="" />
        <div className="ticket-details">
          {AWAITING_ASSIGN && ticket.ticketNumber === AWAITING_ASSIGN ? (
            //Join pool sonrası vrf gelene kadarki kısım (bilet numarası daha belli degil)
            <>
              <div className="detail-id">
                TICKET ID <span>#{ticket.ticketNumber}</span>
              </div>
              <div className="detail-prize">VRF APPROVAL AWAITED</div>
              <div className="detail-s">WAIT FOR TICKET TO WIN!</div>
              <div className="detail-info">"TICKET PENDING"</div>
            </>
          ) : (
            // join pool sonrası ve vrf onayı ile biletin belli olduğu kısım
            <>
              <div className="detail-id">
                TICKET ID <span>#{ticket.ticketNumber}</span>
              </div>
              {ticket.wonPrizeIndex === AWAITING_DRAW ? (
                //Join - locked statuslerinde (daha çekiliş yapılmamışken)
                <>
                  {poolData.status > 3 ? (
                    <>
                      <div className="detail-prize">
                        YOU MISSED OUT
                        <span>THE PRIZE</span>
                      </div>
                      <div className="detail-s">TRY AGAIN!</div>
                      <div className="detail-info">
                        {/* kazanmayan bilet için claimed durumuna bakmaya gerek yok */}
                        "NOT CLAIMED"
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="detail-prize">RAFFLE COMING SOON</div>
                      <div className="detail-s">STAY TUNED TO WIN!</div>
                      <div className="detail-info">"DRAW PENDING"</div>
                    </>
                  )}
                </>
              ) : (
                //Raffle - claim - end statuslerinde
                <>
                  {ticket.isWon &&
                  ticket.wonPrizeIndex === contractInfo.prizeShareCount - 1 ? (
                    //ilgili bilet herhangi bir ödül kazanmışsa ve bu ödül son ödül ise
                    <>
                      <div className="detail-prize">
                        YOU WON PARTICIPATION PRIZE
                        <span style={{ display: "block" }}>
                          {/* TODO: ticket.wonPrizeAmount kontrattan kaldırıldı (ben düzelteceğim) */}
                          {`${fixedAmount(ticket.wonPrizeAmount)} ${
                            poolData.prizeTokenSymbol
                          }`}
                        </span>
                      </div>
                      <div className="detail-s">NICE!</div>
                      <div className="detail-info">
                        {isClaimed ? (
                          <span>"CLAIMED"</span>
                        ) : (
                          <span>"NOT CLAIMED"</span>
                        )}
                      </div>
                    </>
                  ) : (
                    //ilgili bilet herhangi bir ödül kazanmışsa ve bu ödül son büyük ödüllerden biriyse
                    <>
                      {ticket.isWon && ticket.wonPrizeIndex === 0 && (
                        <>
                          <div className="detail-prize">
                            YOU WON GRAND PRIZE
                            <span style={{ display: "block" }}>
                              {/* TODO: ticket.wonPrizeAmount kontrattan kaldırıldı (ben düzelteceğim) */}
                              {`${fixedAmount(ticket.wonPrizeAmount)} ${
                                poolData.prizeTokenSymbol
                              }`}
                            </span>
                          </div>
                          <div className="detail-s">CONGRATULATIONS!</div>
                        </>
                      )}
                      {ticket.isWon && ticket.wonPrizeIndex === 1 && (
                        <>
                          <div className="detail-prize">
                            YOU WON 2ND PRIZE
                            <span style={{ display: "block" }}>
                              {/* TODO: ticket.wonPrizeAmount kontrattan kaldırıldı (ben düzelteceğim) */}
                              {`${fixedAmount(ticket.wonPrizeAmount)} ${
                                poolData.prizeTokenSymbol
                              }`}
                            </span>
                          </div>
                          <div className="detail-s">
                            <span>FANTASTIC!</span>
                          </div>
                        </>
                      )}
                      {ticket.isWon && ticket.wonPrizeIndex === 2 && (
                        <>
                          <div className="detail-prize">
                            YOU WON 3RD PRIZE
                            <span style={{ display: "block" }}>
                              {/* TODO: ticket.wonPrizeAmount kontrattan kaldırıldı (ben düzelteceğim) */}
                              {`${fixedAmount(ticket.wonPrizeAmount)} ${
                                poolData.prizeTokenSymbol
                              }`}
                            </span>
                          </div>
                          <div className="detail-s">EXCELLENT!</div>
                        </>
                      )}
                      {ticket.isWon && ticket.wonPrizeIndex === 3 && (
                        <>
                          <div className="detail-prize">
                            YOU WON 4TH PRIZE
                            <span style={{ display: "block" }}>
                              {/* TODO: ticket.wonPrizeAmount kontrattan kaldırıldı (ben düzelteceğim) */}
                              {`${fixedAmount(ticket.wonPrizeAmount)} ${
                                poolData.prizeTokenSymbol
                              }`}
                            </span>
                          </div>
                          <div className="detail-s">GREAT!</div>
                        </>
                      )}
                      <div className="detail-info">
                        {isClaimed ? "CLAIMED" : "NOT CLAIMED"}
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default TicketItem;
